import React, { ReactNode } from 'react'

interface MenuProps {
  children: ReactNode
  align?: 'start' | 'end'
}

const Menu: React.FC<MenuProps> = ({ children, align = 'end' }) => {
  return (
    <div
      className={`menu-container flex flex-row ${align === 'start' ? 'justify-start' : 'justify-end'} gap-4`}
      role='menu'
    >
      {children}
    </div>
  )
}

export default Menu
